module.exports = __webpack_public_path__ + "img/loader.adea50d8.gif";